import React from 'react';
import { apiGet } from '../../../common/helpers/api-helpers';
import './merge-panel.scss';
import { Button } from 'reactstrap'
import { LoadingGlobal, MessageBoxGlobal } from '../../../common/globals/globals';

class MergePanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = { proximity: 25, targetList: null, targetId: null, targetIsField: true, toggleLabel: 'Fields' };

    this.onProxChange = this.onProxChange.bind(this);
    this.getTargets = this.getTargets.bind(this);
    this.onChangeTarget = this.onChangeTarget.bind(this);
    this.toggleFieldsDiscos = this.toggleFieldsDiscos.bind(this);
  }

  componentDidMount() {
    this.getTargets();
  }

  get apiPrefix() { return 'api/resource/' };

  getTargets() {
    const onSuccess = (result) => {
      this.setState({ targetList: result });
    }

    const onFail = (err) => {
      console.log(err);
    }

    apiGet(this.apiPrefix + 'get-merge-targets?sourceId=' + this.props.sourceId + '&proximityKM=' + this.state.proximity + '&targetIsField=' + this.state.targetIsField, LoadingGlobal.show, LoadingGlobal.hide, MessageBoxGlobal, onSuccess, onFail);
  }

  onProxChange(e) {
    var value = Number(e.currentTarget.value);
    this.setState({ proximity: value });
  }

  handleFocus = (event) => event.target.select();

  onChangeTarget(id) {
    this.setState({ targetId: id });
  }

  toggleFieldsDiscos() {
    let targetIsField = this.state.targetIsField;
    let toggleLabel = this.state.targetIsField ? 'Discoveries' : 'Fields';
    this.setState({ targetIsField: !targetIsField, toggleLabel: toggleLabel },() => this.getTargets());
  }

  render() {
    var targets = null;

    if (this.state.targetList === null || this.state.targetList === undefined) return null;

    if (this.state.targetList !== undefined && this.state.targetList !== null && this.state.targetList.length > 0) {
      targets =
        <div className>
          <ul className="labels">
            {this.state.targetList.map(x =>
              <li key={x.key} className={(x.key === this.state.targetId ? 'selected' : '')}>
                <div className="label-name" onClick={() => this.onChangeTarget(x.key)}>{x.value}</div></li>)
            }
          </ul>
        </div>
    }

    return (
      <div className='merge-panel'>
        <div className='main'>

          <div className='source'>
            <span>Source: {this.props.sourceName}</span>
          </div>

          <div className='proximity-area'>
            <span className='prox-label'>Select Proximity distance from target:</span>
            <input id='prox-input' type='number' min='0' value={this.state.proximity} onChange={this.onProxChange} onClick={this.handleFocus} ></input>
            <span className='km-label'>km</span>
            <Button className="update-button" size="sm" onClick={this.getTargets}>Update</Button>
          </div>

          <div className="toggle">
            <h4 className="toggle-label">{this.state.toggleLabel}</h4>
            <label className="switch">
              <input type="checkbox" defaultChecked={this.state.targetIsField} onClick={this.toggleFieldsDiscos} />
              <span className="slider round" />
            </label>
          </div>

          <div className="target">
            <span>Select Target:</span>
            <div className="option-list">
              {targets}
            </div>
          </div>
        </div>

        <div className='buttons'>
          <Button className="ok-button" size="sm" disabled={this.state.targetId === null} onClick={() => this.props.doMerge(this.props.sourceId, this.state.targetId, this.state.targetIsField)}>Ok</Button>
          <Button className="cancel-button" size="sm" onClick={() => this.props.onClose()}>Cancel</Button>
        </div>
      </div>

    );
  }


};

export default MergePanel;